import { useContext } from 'react';
import ListContext from '../context/listContext';

function useList(index: number) {
  const context = useContext(ListContext);
  return {
    distanceToIndex: index - (context.listIndex || 0),
    focused: context.listFocused,
    fixed: context.listFixed,
    listIndex: context.listIndex,
    setListIndex: context.setListIndex,
    focusedByParent: context.focusedByParent,
  };
}

export default useList;
